export default "__VITE_PUBLIC_ASSET__8a080209__"